import axios from 'axios';

import { authenticator } from 'modules/wolt-auth';

import fetchStream, { FetchStreamOptions } from './fetchStream';
import {
  AssetsResult,
  GetEntityAssetsRequest,
  PrepareAssetRequest,
  PreparedAsset,
  TemplatesResult,
  GetEnhancedAssetsRequest,
  PromotedAsset,
} from './types';

const assetRepositoryServiceApi = axios.create({
  baseURL: process.env.ASSET_REPOSITORY_SERVICE_URI,
});

export default assetRepositoryServiceApi;

export const prepareAssets = (params: PrepareAssetRequest) =>
  assetRepositoryServiceApi.post<PreparedAsset[]>('/v1/assets', params).then(response => response.data);

export const getEntityAssets = ({
  source,
  sourceId,
  scope,
  scopeId,
  size,
  cursor,
}: GetEntityAssetsRequest): Promise<AssetsResult> =>
  assetRepositoryServiceApi
    .get('/v1/assets', { params: { source, sourceId, scope, scopeId, size, cursor } })
    .then(response => response.data);

export const archiveAssets = (assetIds: string[]) =>
  assetRepositoryServiceApi.delete(`/v1/assets?id=${assetIds.join('&id=')}`);

export const getImageEnhancementTemplates = (): Promise<TemplatesResult> =>
  assetRepositoryServiceApi.get('/v1/enhancements/templates').then(response => response.data);

export const getEnhancedAssetsStream = async (
  { assetIds, templateId }: GetEnhancedAssetsRequest,
  { onMessage }: FetchStreamOptions,
): Promise<void> =>
  fetchStream(
    process.env.ASSET_REPOSITORY_SERVICE_URI + '/v1/enhancements',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${await authenticator.getAccessToken()}`,
      },
      body: JSON.stringify({ assetIds, templateId }),
    },
    { onMessage },
  );

export const promoteEnhancedAssets = (assetIds: string[], templateId: string): Promise<PromotedAsset[]> =>
  assetRepositoryServiceApi.post('/v1/enhancements/promote', { assetIds, templateId }).then(response => response.data);
